var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenmo = function SvgVenmo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.276 1.25c.743-.15 1.528.173 1.79.884.274.745.401 1.542.401 2.466 0 4.23-3.419 9.654-6.424 13.689-.335.45-.865.711-1.427.711H5.91a1.8 1.8 0 0 1-1.775-1.502L1.85 3.889A1.8 1.8 0 0 1 3.456 1.8l2.57-.243a1.8 1.8 0 0 1 1.956 1.57L9.276 13.5c1.41-2.29 3.152-5.89 3.152-8.344 0-.764-.075-1.389-.206-1.925-.139-.57.172-1.2.747-1.315z"
  })));
};
export default SvgVenmo;